export const DEFAULT_BROWSER = {
    mobile: false,
};
